import type { IconProps } from '@carboncopyco/icons';
import classNames from 'classnames';
import type { BgColors } from '../../constants';
import { TooltipBubble } from '../TooltipBubble';

export interface NavbarIconProps {
  bgColor?: BgColors;
  icon: React.ReactElement<IconProps>;
  label?: string;
}

export const NavbarIcon = ({ bgColor, icon: Icon, label }: NavbarIconProps) => {
  return (
    <TooltipBubble
      placement="right"
      title={label}
      disabled={!label}
    >
      <div
        className={classNames(
          'w-ds-15 h-ds-15 flex items-center justify-center shrink-0 grow-0 mr-2.5',
          bgColor,
          bgColor ? 'text-white' : 'text-black'
        )}
        aria-label={label}
      >
        {Icon}
      </div>
    </TooltipBubble>
  );
};
